// Auto generated file, do not manually modify!
// com.hotpads.admanagement.client.enums.AdManagementInvoiceOwnerRecipientType

export enum AdManagementInvoiceOwnerRecipientType {
  MANAGEMENT_COMPANY = 'MANAGEMENT_COMPANY',
  PROPERTY = 'PROPERTY',
}

export const AdManagementInvoiceOwnerRecipientType_values = [
  AdManagementInvoiceOwnerRecipientType.MANAGEMENT_COMPANY,
  AdManagementInvoiceOwnerRecipientType.PROPERTY,
] as const;
